<template>
    <div>
        <div class="query-content">
            <van-nav-bar title="流量使用量及状态查询" @click-left="goHome" left-text="返回" left-arrow></van-nav-bar>
            <!--<div class="page-title">流量使用量及状态查询</div>-->
            <div class="page-content">
                <fieldset class="md-field">
                    <div class="md-field-item-content">
                        <label class="md-field-item-title">卡板操作</label>
                        <div class="md-field-item-control">
                            <a v-if="operator.imeiBind==1 && rebind == true" @click="resetImei">机卡解绑</a>
                            <a v-clipboard:copy="iccid" v-clipboard:success="onCopySuccess"
                               v-clipboard:error="onCopyError">复制卡号</a>
                            <a v-if="operator.authUrl" :href="operator.authUrl">活体实名</a>
                            <a @click="refresh">刷新</a>
                            <!--<a @click="handleWxUnbind">微信解绑</a>-->
                        </div>
                    </div>
                    <div class="md-field-item-content">
                        <label class="md-field-item-title">查询卡板</label>
                        <div class="md-field-item-control" @click="cardModal=true">
                            <input id="copy_phone" :value="iccid" disabled>
                        </div>
                        <div class="md-field-item-right">
                            <van-icon
                                    name="arrow"
                            >
                            </van-icon>
                        </div>
                    </div>
                </fieldset>
                <fieldset class="md-field"><!---->
                    <div class="md-field-content">
                        <van-progress :percentage="leftPercent"  stroke-width="36" />
                    </div>
                </fieldset>
              <template v-if="operator.system!='SHUANGKAONE'">
                <fieldset class="md-field"><!---->
                    <div class="md-field-content">
                        <div class="card-state md-tab-bar">
                            <div class="flow-item">
                                <div class="item-title">卡板状态</div>
                                <div class="item-content">
                                    <!--<span class="dot-gray state-dot"></span>-->
                                    <span>{{simStatusName}}</span></div>
                            </div>
                            <div class="split"></div>
                            <div class="flow-item">
                                <div class="item-title">实名状态</div>
                                <div class="item-content">
                                    <span>{{simAuthStatusName}}</span>
                                </div>
                            </div>
                        </div>
                    </div> <!----></fieldset>
              </template>
              <template v-else>
                <fieldset class="md-field deviceInfo" >
                  <div class="device-box">
                    <div class="title">
                      <span>WiFi信息</span>
                      <div class="wifi-btn">
                        <span @click="resetDevice">恢复出厂</span>
                        <span @click="saveSsid" v-if="showSaveSsid==true">应用WiFi修改</span>
                      </div>
                    </div>
                    <div class="wifi-box">
                      <div class="md-field-item-content">
                        <label class="md-field-item-title">WiFi名称</label>
                        <div class="md-field-item-control">
                          <input :placeholder="deviceInfo.ssid" v-model="editSsid.ssid">
                        </div>
                      </div>
                      <div class="md-field-item-content">
                        <label class="md-field-item-title">WiFi密码</label>
                        <div class="md-field-item-control">
                          <input :placeholder="deviceInfo.password" v-model="editSsid.password">
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="md-field-item-content" v-for="(item,type) in shuangka" :key="type" style="display: block;padding: .14rem 0;">
                    <div class="md-field-item-content" style="border: none;min-height: .5rem">
                      <label class="md-field-item-title">{{operatorType[type]}}</label>
                      <div class="md-field-item-control">
                        {{item.iccid}}
                      </div>
                      <div class="md-field-item-right" @click="qieka(type,item.simIndex)" v-if="item.using==0">
                        切换<van-icon name="arrow"></van-icon>
                      </div>
                      <div class="md-field-item-right" v-else style="color:#00a720;">
                        当前使用
                      </div>
                    </div>
                    <div class="btns md-field-item-content" style="border: none;min-height: .5rem;">
                      <div class="shuangka-status">
                        <span v-if="item.statusName" :class="item.statusName=='在用' || item.statusName=='已激活' || item.statusName=='正常' ? 'success':'error'">{{item.statusName}}</span>
                        <span :class="{success:item.auth==1,error:item.auth==0}">{{item.auth==1?'已实名':'未实名'}}</span>
                      </div>
                      <div class="shuangka-btns">
                <span v-clipboard:copy="item.iccid" v-clipboard:success="onCopySuccess"
                      v-clipboard:error="onCopyError">复制号码</span>
                        <a :href="item.authUrl" v-if="(item.auth==0 || !item.auth) && (!shuangka.liantong || shuangka.liantong.auth==1 || type =='liantong')">去实名</a>
                      </div>
                    </div>
                  </div>
                </fieldset>
              </template>
                <fieldset class="md-field">
                    <div class="md-field-content">
                        <div class="card-state md-tab-bar">
                            <div class="flow-item" :style="{color:'#409EFF'}">
                                <div class="item-title"  :style="{color:'#409EFF'}">总流量</div>
                                <div class="item-content">
                                    <!--<span class="dot-gray state-dot"></span>-->
                                    <span>{{totalUsage}}G</span></div>
                            </div>
                            <div class="split"></div>
                            <div class="flow-item"  :style="{color:'#F56C6C'}">
                                <div class="item-title"  :style="{color:'#F56C6C'}">剩余流量</div>
                                <div class="item-content">
                                    <span>{{remainUsage}}G</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </fieldset>

                <fieldset class="package-list md-field">
                    <template v-if="packageList.length > 0">
                        <van-row v-for="(item,index) in packageList" :key="index" :style="{fontSize:'.3rem'}">
                            <van-col span="22" :class="{'status-over':item.process == 0,'status-using':item.process==1,'status-wait':item.process==2}">
                                <span style="float: left;" v-if="item.package">{{item.package.title}}</span>
                                <span style="float: left;" v-else>{{totalUsage}}G 套餐</span>
                                <span style="float: right;">{{item.startDate}}至{{item.endDate}}</span>
                            </van-col>
                            <van-col span="2">
                                <van-icon @click="showNextTips(item)"  v-if="item.type==1 && item.send_status==0" :style="{fontSize:'.36rem',color:'#F56C6C'}" name="question-o" />
                            </van-col>
                        </van-row>
                    </template>
                    <p v-else :style="{color:'#F56C6C',fontSize:'.3rem'}">
                        请点击下方按钮，充值套餐后以畅享网络
                    </p>
                </fieldset>
                <fieldset class="md-field">
                    <div class="md-field-content">
                        <div  v-if="change==0" @click="handleRechargeBtnClick" class="md-button primary active block">
                            <div class="md-button-inner">
                                <div class="md-button-content"><span>充值套餐</span></div>
                            </div>
                        </div>
                        <div  v-else  class="md-button primary inactive block" disabled >
                            <div class="md-button-inner">
                                <div class="md-button-content"><span>充值套餐</span></div>
                            </div>
                        </div>
                    </div>
                </fieldset>

            </div>
        </div>
        <div class="warm-tips"><h5>说明</h5>
            <ol>
                <li>卡板状态显示正常无法正常上网查找设备设置及本地信号问题</li>
                <li>显示停机查看下方流量是否已经用完。如没有流量请充值</li>
                <li>显示停机。还有流量应考虑是更新设备或卡槽造成。请联系客服（提供新设备的IMEI码）</li>
            </ol>
        </div>
        <van-action-sheet
                v-model="cardModal"
                :actions="cardlist"
                cancel-text="取消"
                @select="handleChooseCard"
        />
        <van-dialog
                v-model="inputImeiModal"
                title="输入IMEI"
                show-cancel-button
                @confirm="handleImeiInput"
        >
            <van-cell-group>
                <van-field v-model="imei" type="number" placeholder="请输入设备IMEI"/>
            </van-cell-group>
        </van-dialog>

      <van-dialog
        v-model="inputImeiModal2"
        title="输入IMEI"
        show-cancel-button
        @confirm="handleImeiInput"
      >
        <van-cell-group>
          <van-field v-model="imei" type="number" placeholder="新IMEI"/>
        </van-cell-group>
        <van-cell-group>
          <van-field v-model="oldimei" type="number" placeholder="原IMEI"/>
        </van-cell-group>
      </van-dialog>
      <van-dialog v-model="showQRcodeModal" :showConfirmButton="false" title="长按关注官方公众号">

        <img :src="qrcodeurl" style="display: block;width: 100%;"/>
        <div >续费查询，24小时客服在线</div>
        <a v-clipboard:copy="iccid" v-clipboard:success="onCopySuccess"
           v-clipboard:error="onCopyError" style="padding: .2rem 0;display: block;color: #3a8ee6">复制号码
        </a>
      </van-dialog>
    </div>
</template>

<script>
    //import PackageInfo from "../components/packageInfo"
    //import {swiper, swiperSlide} from "vue-awesome-swiper"
    import Vue from "vue";
    import VueClipboard from 'vue-clipboard2'

    Vue.use(VueClipboard)
    //import "../assets/css/swiper.min.css"

    export default {
        name: "index",
        // components: {PackageInfo, swiper, swiperSlide},
        data() {
            return {
              oldimei:'',
              operatorType:{
                liantong:"中国联通",
                dianxin:'中国电信',
                yidong:'中国移动',
              },
              inputImeiModal2:false,
                iccid: '',
                cardModal: false,
                inputImeiModal: false,
                imei: '',
                /*swiperOption: {
                    centeredSlides: true,
                    slidesPerView:2,
                    spaceBetween : 80,
                    slidesOffsetBefore:-40
                },*/
              editSsid:{ssid:'',password:''},
              deviceInfo:{},
                cardlist: [],
                packageList: [],
                /*currentPackage: {
                     total:0,
                     used:0,
                     startDate:'--',
                     endDate:'--'
                 },
                 nextPackage: {
                    total:0,
                    used:0,
                    startDate:'--',
                    endDate:'--'
                },*/
                totalUsage:0,
                remainUsage:0,
                simStatusName: '未知状态',
                simAuthStatus: '',
                unbindNeedImei: 0,
                operator: {},
                rebind:0,
                change:0,
              qrcodeurl:'',
              shuangka: {
                liantong: {},
                dianxin: {},
                yidong:{}
              },
              showQRcodeModal:false
            };
        },
        computed: {
          showSaveSsid(){
            if(this.editSsid.ssid.length>0 || this.editSsid.password.length>0){
              return true
            }
            return false
          },
            swiper() {
                return this.$refs.mySwiper.swiper
            },
            simAuthStatusName() {
                return this.simAuthStatus == 1 ? '已实名' : '未实名'
            },
            leftPercent(){
                if(this.totalUsage > 0){
                    return parseInt(this.remainUsage / this.totalUsage * 100);
                }else{
                    return 0;
                }
            },
            pivotText(){
                return "剩余流量"+this.remainUsage+'G，总流量'+this.totalUsage+'G，剩余比例 '+this.leftPercent+'%'
            }
        },
        watch: {
            iccid(value) {
                sessionStorage.setItem('iccid', this.iccid)
              this.subscribeStatus()
                this.queryPackageList();
                this.queryOperatorInfo();
                /*this.queryResetImeiType()*/
                this.queryCardStatus();
            }
        },
        created: function () {
            let iccid = this.$route.query.iccid;
            if(iccid){
                this.iccid = iccid;
            }
            this.queryUserCards();
        },
        methods: {
          resetDevice(){
            this.$dialog.alert({
              title: "提示",
              message: "恢复出厂设置会使设备重启，并且重置WiFi名称和密码，确认恢复出厂",
              confirmButtonText: '确认',
              showCancelButton: true
            }).then(() => {

              this.$toast.loading('发送中', {duration: 0});
              this.fetchData('/card/resetDevice',{iccid:this.iccid} , res => {
                this.$toast.clear()
                if (res.code) {
                  this.$toast.success(res.msg);
                } else {
                  this.$toast.fail(res.msg);
                }
              })

            });
          },
          saveSsid(){
            if(!this.editSsid.ssid || /^[a-zA-z\d_]+$/.test(this.editSsid.ssid) == false){
              return this.$toast.fail('请输入字母数字下划线组成的WiFi名称');
            }
            if(!this.editSsid.password || /^[a-zA-z\d_]{8,}$/.test(this.editSsid.password) == false){
              return this.$toast.fail('密码最低8位，支持数字字母下划线');
            }
            this.editSsid.iccid = this.iccid
            this.$toast.loading('发送中', {duration: 0});
            this.fetchData('/card/savessid', this.editSsid , res => {
              this.$toast.clear()
              if (res.code) {
                this.$toast.success(res.msg);
              } else {
                this.$toast.fail(res.msg);
              }
            })


          },
          qieka(type,simIndex){
            this.$dialog.alert({
              title: "提示",
              message: "提示指令发送成功后，切换网络过程中，会有短暂断网，设备可能会自动重启，此过程可能需要5分钟",
              confirmButtonText: '立即切换',
              showCancelButton: true
            }).then(() => {

              this.$toast.loading('切换中', {duration: 0});
              this.fetchData('/card/shuangkaqieka',{simIndex:simIndex,iccid:this.iccid} , res => {
                this.$toast.clear()
                if (res.code) {
                  this.$toast.success(res.msg);
                } else {
                  this.$toast.fail(res.msg);
                }
              })

            });
          },
          subscribeStatus(){
            this.fetchData('/auth/subscribeStatus',{iccid:this.iccid},res=>{
              if(res.code && res.url){
                this.showQRcodeModal = true
                this.qrcodeurl = res.url
              }
            })
          },
            handleRechargeBtnClick() {
                this.$router.push({name: 'recharge', query: {iccid: this.iccid}})
            },
            queryOperatorInfo() {
                this.fetchData('/card/cardOperator', {iccid: this.iccid}, (res) => {
                    if (res.code) {
                        this.operator = res.data
                    }else{
                        this.$toast.fail(res.msg)
                    }
                })
            },
            changeCard(iccid){
                this.fetchData('/change/getUrl',{iccid:iccid},(res)=>{
                    if(res.code && res.url){
                        window.location.href = res.url
                    }else{
                        this.$router.push({name:'change',query:{iccid:iccid}})
                    }
                })
            },
            queryUserCards() {
                this.fetchData('/card/querylist', {}, (res) => {
                    if (res.code) {
                        for (var i in res.data) {
                            let card = res.data[i];
                            this.cardlist.push({
                                name: card.iccid,
                                value: card.iccid
                            })
                            if (card.default == 1 && !this.iccid) {
                                this.iccid = card.iccid;
                            }
                        }
                    } else {
                        this.$dialog.alert({
                            title: false,
                            message: "检测到您还未绑卡，请先绑卡",
                            confirmButtonText: '去绑卡'
                        }).then(() => {
                            this.$router.push({name: 'bind'})
                        });

                    }
                })
            },
            queryPackageList() {
                this.fetchData('/package/monthlist', {iccid: this.iccid}, (res) => {
                    if (res.code) {
                        this.packageList = res.data
                    } else {
                        this.$toast.fail('查询失败');
                    }
                })
            },
            queryCardStatus() {
                this.$toast.loading({message: '加载中',duration:50000});
                this.fetchData('/card/status', {iccid: this.iccid}, (res) => {
                    this.$toast.clear()
                    if (res.code) {
                        if(res.data.change == 1){
                            this.change = 1
                            if(this.operator.exchangeSwitch==1){
                                this.$dialog.alert({
                                    title: false,
                                    message: "当前卡已不支持续费，我们将为您补发一张卡",
                                    confirmButtonText: '立即换卡',
                                    showCancelButton:true
                                }).then(() => {
                                    this.changeCard(this.iccid)
                                });
                            }
                        }else if(res.data.change==2 && res.data.id){

                            this.$dialog.alert({
                                title: false,
                                message: "您已申请换卡，点击查看换卡进度",
                                confirmButtonText: '立即查看',
                                showCancelButton:true
                            }).then(() => {
                                this.$router.push({name:'changeInfo',query:{id:res.data.id}})
                            }).catch(()=>{});

                        }else {
                            this.simStatusName = res.data.simStatusName;
                            this.simAuthStatus = res.data.simAuthStatus;
                            this.totalUsage = res.data.total;
                            this.remainUsage = res.data.remain
                            this.rebind = res.data.rebind
                            if (!this.simAuthStatus && this.operator.authUrl) {
                                this.$dialog.confirm({
                                    title: '实名提示',
                                    message: '未查询到卡的实名信息，点击确定去实名'
                                }).then(() => {
                                    // on confirm
                                    window.location.href = this.operator.authUrl
                                }).catch(() => {
                                    // on cancel
                                });
                            }

                          if (res.data.data && res.data.data.shuangka) {
                            this.shuangka = res.data.data.shuangka
                            if (!this.totalUsage) {
                              //先续费再实名
                              this.$dialog.alert({
                                title: '温馨提示',
                                message: '当前设备无套餐，请先充值'
                              }).then(() => {
                                // on confirm
                                this.handleRechargeBtnClick()
                              });
                              return false;
                            }
                            for (let i in this.shuangka) {
                              this.fetchData('/card/status', {iccid: this.shuangka[i].iccid}, (res) => {
                                this.shuangka[i].statusName = res.data.simStatusName;
                                this.shuangka[i].auth = res.data.simAuthStatus;
                                if (i == 'dianxin' && this.shuangka[i].auth == 0 && this.shuangka[i].mustdianxin) {
                                  this.operator.authUrl = this.shuangka[i].authUrl
                                  this.showCopy = true
                                }
                              })
                            }
                            this.fetchData('/card/deviceInfo', {iccid: this.iccid}, (res) => {
                              this.deviceInfo = res.data
                            })

                          }
                        }
                    }else{
                        this.$toast.fail(res.msg)
                    }
                })
            },
            refresh(){
                this.queryPackageList();
                this.queryCardStatus();
            },
            /*queryResetImeiType() {
                this.fetchData('/card/resetImeiType', {iccid: this.iccid}, (res) => {
                    if (res.code) {
                        this.unbindNeedImei = res.data
                    }
                })
            },*/
            resetImei() {
                if(this.operator.imeiMsg) {
                    this.$dialog.confirm({
                        title: '注意',
                        message: this.operator.imeiMsg,
                    })
                        .then(() => {
                           this.doReset()
                        })
                        .catch(() => {
                            console.log('cancel')
                        });
                }else{
                    this.doReset()
                }
            },
            doReset(){
                if (this.operator.needImei == 0) {
                    //不需要上报imei
                    this.$toast.loading('解绑中')
                    let url
                    if(this.operator.autoImei == 1){
                        url = '/card/active'
                    }else{
                        url = '/card/resetImei'
                    }
                    this.fetchDataPost(url, {iccid: this.iccid, imei: this.imei,oldImei:this.oldimei}, (res) => {
                        this.$toast.clear();
                        if (res.code) {
                            this.$toast.success(res.msg)
                        } else {
                            this.$toast.fail(res.msg)
                        }
                    })

                } else if(this.operator.needImei==1){
                  this.inputImeiModal = true;
                }else {
                  this.inputImeiModal2 = true;
                }
            },
            handleImeiInput() {
                if (!this.imei) {
                    this.$toast.fail('请输入IMEI');
                    this.close()
                } else {
                    let url
                    if(this.operator.autoImei == 1){
                        url = '/card/active'
                    }else{
                        url = '/card/resetImei'
                    }

                    this.fetchDataPost(url, {iccid: this.iccid, imei: this.imei,oldImei:this.oldimei}, (res) => {
                        if (res.code) {
                            this.inputImeiModal = false;
                            this.$toast.success(res.msg)
                        } else {
                            this.$toast.fail(res.msg)
                        }
                    })
                }
            },
            handleChooseCard(row) {
                this.iccid = row.value;
                this.cardModal = false;
            },
            handleWxUnbind() {
                this.$dialog.confirm({
                    message: '解绑后需重新绑定才能查询充值，确认解绑？'
                }).then(() => {
                    this.fetchDataPost('/card/unbindwx', {iccid: this.iccid}, (res) => {
                        if (res.code) {
                            this.$toast.success(res.msg)
                            this.queryUserCards()
                        } else {
                            this.$toast.fail(res.msg)
                        }
                    })
                }).catch(() => {
                    console.log('cancel')
                });
            },
            showNextTips(item){
                this.$dialog.confirm({
                    message: '这个套餐为次月套餐，如果想要立即使用，请点击确定以转成当月套餐，否则请点击取消',
                    title:'警告'
                }).then(() => {
                    this.fetchDataPost('/order/recharge', {id: item.id}, (res) => {
                        if (res.code) {
                            this.$toast.success(res.msg)
                            this.refresh();
                        } else {
                            this.$toast.fail(res.msg)
                        }
                    })
                }).catch(() => {
                    console.log('cancel')
                });
            },
            onCopySuccess() {
                this.$toast.success('复制成功')
            },
            onCopyError() {
                this.$toast.fail('复制失败');
            }
        }
    };
</script>
<style lang="scss">
  .device-box{
    .title{
      border-bottom: 1px solid #666;
      display: flex;
      padding-bottom: .2rem;
      span{
        flex: 1;
        font-size: .26rem;
        text-align: left;
      }
      .wifi-btn {
        span{
          border: 1px solid #0b8ed4;
          border-radius: 4px;
          padding: 2px;
          color: #0b8ed4;
        }
      }
    }
    .wifi-box{
      .md-field-item-content{
        min-height: .6rem;
        height: .6rem;
        input{
          border: none;
          height: .5rem;
        }
        .md-field-item-title{
          font-size: .28rem;
        }
      }

      .md-button-content{
        width: 3rem;
        height: .4rem;
        text-align: center;
        font-size: .32rem;
        line-height: .4rem;
        background: #0b8ed4;
        color: #fff;
      }
    }
  }
  .change-tips {
    font-size: 13px;
    color: #3f3f3f;
    text-align: left;
    line-height: 20px;
  }
    .md-button {
        display: block;
        height: 1rem;
        line-height: 1rem;
        font-size: 0.36rem;
        font-weight: 500;
        font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", 微软雅黑, Arial, sans-serif;
        text-align: center;
        box-sizing: border-box;
        -webkit-appearance: none;
        user-select: none;
        -webkit-tap-highlight-color: transparent;
        border-width: initial;
        border-style: none;
        border-color: initial;
        border-image: initial;
        border-radius: 0.04rem;
        outline: 0px;
        transition: all 0.3s ease 0s;
        overflow: visible;
        position: relative;
    }

    .status-using{
        color: #2f86f6!important;
    }
    .status-over{
        color: #9f9f9f !important;
    }
    .status-waiting{
        color: #9f9f9f !important;
    }
    .md-button.primary {
        background: #2f86f6;
        color: #fff;
    }

    .md-button.block {
        width: 100%;
    }

    .md-button.inactive {
        opacity: .3;
    }

    .md-button-inner {
        display: -webkit-box;
        display: -webkit-flex;
        display: flex;
        -webkit-box-align: center;
        -webkit-align-items: center;
        align-items: center;
        -webkit-box-pack: center;
        -webkit-justify-content: center;
        justify-content: center;
        width: 100%;
        height: 100%;
        overflow: hidden;
        text-overflow: ellipsis;
        word-break: break-all;
        word-wrap: break-word;
        white-space: nowrap;
    }

    .query-content {
        background: #fff;
        font-size: .12rem;
        margin: .2rem auto;
        -webkit-box-shadow: 0 0 1px #dedede;
        box-shadow: 0 0 1px #dedede;
        border-radius: .1rem;
    }

    .package-list p span {
        line-height: 2;

        &:first-child {
            float: left;
        }

        &:last-child {
            float: right;
        }
    }

    .query-content .page-title {
        margin: .3rem 0 0 0;
        font-size: .3rem;
        height: .8rem;
        line-height: .8rem;
        border-radius: .2rem .2rem 0 0;
        border-bottom: 1px solid #fafafa;
        color: #888;
        text-align: center;
    }

    .page-content {
        padding-bottom: .1rem;
        min-height: 6rem;
        border-radius: 0 0 .2rem .2rem;
        background: #fff;
    }

    .md-field {
        padding: .1rem .2rem;
        border: none;
    }

    .package-list {
        margin-top: .1rem;
    }

    .md-input-item-input {
        width: 100%;
        height: 1rem;
        color: rgb(17, 26, 52);
        font-size: 0.32rem;
        font-weight: 500;
        font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", 微软雅黑, Arial, sans-serif;
        line-height: 1;
        box-sizing: border-box;
        -webkit-tap-highlight-color: transparent;
        -webkit-appearance: none;
        border-width: initial;
        border-style: none;
        border-color: initial;
        border-image: initial;
        background: 0px 0px;
        outline: 0px;
    }

    imei-input {
        width: 4.8rem;
        text-align: center !important;
    }

    .md-field-item-content {
        position: relative;
        display: -webkit-box;
        display: -webkit-flex;
        display: flex;
        -webkit-box-align: center;
        -webkit-align-items: center;
        align-items: center;
        -webkit-box-pack: justify;
        -webkit-justify-content: space-between;
        justify-content: space-between;
        min-height: 1rem;
        /*padding-top: .3rem;
        padding-bottom: .3rem;*/
        box-sizing: border-box;
        border-bottom: 1px solid #ccc;
    }

    .md-field-item-title {
        text-align: left;
        width: 1.6rem;
        -webkit-flex-shrink: 0;
        flex-shrink: 0;
        font-size: .32rem;
    }

    .md-field-item-control {
        text-align: left;
        position: relative;
        -webkit-box-flex: 1;
        -webkit-flex: 1 1 0%;
        flex: 1 1 0%;
        color: #111a34;
        font-size: .32rem;
        font-weight: 500;
        padding: 0;
        margin: 0;
        line-height: 1.15;
        border: none;
        background: none;
        outline: none;
        border: 0;
    }

    .md-field-item-control a {
        margin: 0 .1rem;
        font-size: .26rem;
        color: #3a8ee6;
        white-space: nowrap;
    }

    #copy_phone {
        border: none;
        font-weight: 500;
        width: 100%;
        height: .36rem;
        font-size: .32rem;
        user-select: none;
    }

    #copy_phone:disabled {
        background: none;
    }

    .md-field-item-right {
        position: relative;
        -webkit-flex-shrink: 0;
        flex-shrink: 0;
        margin-left: .12rem;
        display: -webkit-inline-box;
        display: -webkit-inline-flex;
        display: inline-flex;
        -webkit-box-align: center;
        -webkit-align-items: center;
        align-items: center;
        -webkit-box-pack: end;
        -webkit-justify-content: flex-end;
        justify-content: flex-end;
        color: #858b9c;
        font-size: .28rem;
    }


    .card-state {
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        padding: .2rem 0 .1rem 0;
    }

    .card-state .flow-item {
        font-size: .36rem;
        text-align: center;
        -webkit-box-flex: 1;
        -ms-flex: 1;
        flex: 1;
    }

    .card-state .split {
        border-left: 1px solid #fafafa;
        min-height: .4rem;
    }

    .card-state .flow-item .item-title {
        color: #888;
        font-size: .34rem;
    }

    .md-tab-bar {
        position: relative;
        padding-left: .4rem;
        padding-right: .4rem;
        background-color: #f9fafb;
    }

    .dot-gray {
        position: relative;
    }

    .card-state .flow-item .item-content .state-dot {
        margin-top: .08rem;
    }

    .dot-gray:after {
        content: "";
        position: absolute;
        z-index: 1;
        top: 0;
        left: 0;
        -webkit-box-shadow: 0 0 0.1rem #888 inset;
        box-shadow: inset 0 0 0.1rem #888;
    }

    /*.dot-gray:after {
        width: .12rem;
        height: .12rem;
        background-color: #888;
        border-radius: 50%;
    }*/
  .shuangka-status{
    span{
      border: 1px solid #fff;
      padding: 2px;
      font-size: .24rem;
      border-radius: 4px;
    }
    .success{
      color: #2bdb90;
      border-color: #2bdb90;
    }
    .error{
      color: #ff2c27;
      border-color: #ff2c27;
    }
  }
  .shuangka-btns{
    span,a{
      border: 1px solid #0b8ed4;
      padding: 2px;
      border-radius: 4px;
      font-size: .24rem;
      color: #0b8ed4;
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/index.vue